/** Public-facing product name for auth & platform chrome */
export const AUTH_BRAND = "wulooj"
